<template>
  <transition name="modal">
    <div class="modal-mask-product">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="form-card__header">
            <h6 class="form-card__title">
              <i :class="client.id == null ? 'bi bi-person-plus' : 'bi bi-pencil'"></i>
              {{ client.id == null ? 'Nuevo cliente' : 'Editar cliente' }}
            </h6>
            <button type="button" class="form-card__btn" @click="close()">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>
          <div class="modal-body form-card form-card--bare">
            <div v-if="client.id != null" class="form-card__field d-flex justify-content-end">
              <label class="toggle-switch">
                <span class="toggle-switch__text">{{ client.active ? 'Activo' : 'Inactivo' }}</span>
                <input v-model="client.active" type="checkbox" :true-value="1" :false-value="0">
                <span class="toggle-switch__slider"></span>
              </label>
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="client-iva">Tipo de IVA</label>
              <q-select v-model="client.iva_type" :options="ivaTypeOptions" placeholder="- Seleccionar tipo de IVA -" />
              <div class="form-card__hint">Obligatorio. Definí el tipo antes de continuar.</div>
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="client-cuit">CUIT / DNI</label>
              <div class="d-flex" style="gap: 8px;">
                <input id="client-cuit" v-model.trim="client.cuit" type="text" class="form-control" placeholder="CUIT / DNI" :class="{ 'is-invalid': codigoValido === false }" :disabled="!client.iva_type" autocomplete="off">
                <button
                  type="button"
                  class="form-card__btn form-card__btn--primary"
                  :disabled="!client.iva_type || !client.cuit || client.cuit.length !== 11"
                  @click="getAfipClientData()"
                >
                  <i class="bi bi-cloud-download"></i>
                  ARCA
                </button>
              </div>
              <div class="form-card__hint">Consultá el CUIT en ARCA y completá el formulario.</div>
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="client-name">Nombre cliente</label>
              <input id="client-name" v-model.trim="client.name" type="text" class="form-control" placeholder="Nombre cliente" :disabled="!client.iva_type" autocomplete="name">
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="client-business">Razón social</label>
              <input id="client-business" v-model.trim="client.business" type="text" class="form-control" placeholder="Razón social" :disabled="!client.iva_type" autocomplete="organization">
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="client-phone1">Teléfono</label>
              <input id="client-phone1" v-model.trim="client.phone_1" type="tel" class="form-control" placeholder="Teléfono" autocomplete="tel">
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="client-phone2">Teléfono celular</label>
              <input id="client-phone2" v-model.trim="client.phone_2" type="tel" class="form-control" placeholder="Teléfono celular" autocomplete="mobile tel">
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="client-email">E-mail</label>
              <input id="client-email" v-model.trim="client.email" type="email" class="form-control" placeholder="E-mail" autocomplete="email">
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="client-address">Dirección</label>
              <input id="client-address" v-model.trim="client.address" type="text" class="form-control" placeholder="Dirección" autocomplete="street-address">
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="client-province">Provincia</label>
              <input id="client-province" v-model.trim="client.province" type="text" class="form-control" placeholder="Provincia" autocomplete="address-level1">
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="client-city">Localidad</label>
              <input id="client-city" v-model.trim="client.city" type="text" class="form-control" placeholder="Localidad" autocomplete="address-level2">
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="client-postalcode">Código postal</label>
              <input id="client-postalcode" v-model.trim="client.postalcode" type="text" class="form-control" placeholder="Código postal" autocomplete="postal-code">
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="client-pricelist">Lista de precios</label>
              <q-select v-model="client.price_list_id" :options="priceListOptions" placeholder="Ninguna" />
            </div>

            <div v-if="client.id == null" class="form-card__field">
              <label class="form-card__label" for="client-amount">Saldo inicial</label>
              <input id="client-amount" v-model="client.amount" type="number" class="form-control" placeholder="0.00">
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="client-limit">Límite de cuenta corriente</label>
              <input id="client-limit" v-model="client.limit" type="number" class="form-control" placeholder="0">
            </div>

            <div v-if="paymentMethodCC === 1" class="form-card__field">
              <div class="form-check">
                <input id="cc_only" v-model="client.cc_only" class="form-check-input" type="checkbox">
                <label class="form-check-label" for="cc_only">Vender por defecto a cuenta corriente</label>
              </div>
            </div>

            <div v-if="salesclerkModule === 1" class="form-card__field">
              <label class="form-card__label" for="client-clerk">Vendedor asociado</label>
              <q-select v-model="client.salesclerk_id" :options="salesClerkOptions" placeholder="Ninguno" />
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="client-discount">Descuento (%)</label>
              <input id="client-discount" v-model="client.discount" type="number" step="0.01" class="form-control" placeholder="0.00">
            </div>

            <div class="form-card__field">
              <label class="form-card__label" for="client-notes">Notas</label>
              <textarea id="client-notes" v-model="client.notes" class="form-control" rows="2"></textarea>
            </div>

            <div class="form-card__field">
              <SelectTransports
                :initialTransports="client.t_linked"
                @updateTransports="updateTransports"
              />
            </div>
          </div>
          <div class="form-card__footer">
            <button type="button" class="form-card__btn" @click="close">Cancelar</button>
            <button type="button" class="form-card__btn form-card__btn--primary" :disabled="isSaving" @click="saveClient()">
              <i class="bi bi-check-lg"></i>
              {{ btnmessage }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import SelectTransports from "./Select-transports.vue";
import QSelect from '@/components/shared/QSelect.vue';
import { mapState } from 'vuex';

  export default {
    components: { SelectTransports, QSelect },
    props: ['clientId'],        
    data() {
      return {
        hasPermission: false,
        isSaving: false,
        salesclerkModule: 0,
        paymentMethodCC: 0,
        btnmessage: "Agregar Cliente",
        client: {
          id: null,
          name: "",
          code: null,
          address: null,
          postalcode: null,
          phone_1: null,
          phone_2: null,
          email: null,
          cuit: null,
          iva_type: null,
          business: null,
          discount: 0,
          limit: null,
          cc_only: null,
          city: null,
          province: null,
          price_list_id: null,
          salesclerk_id: null,
          amount: null,
          t_list: null,
          notes: null,
          active:1
        },

        emptyClient: {
          id: null,
          name: "",
          code: null,
          address: null,
          postalcode: null,
          phone_1: null,
          phone_2: null,
          email: null,
          cuit: null,
          iva_type: null,
          business: null,
          discount: 0,
          limit: null,
          cc_only: null,
          city: null,
          province: null,
          price_list_id: 1,
          salesclerk_id: null,
          amount: null,
          t_list: null,
          notes: null,
          active:1
        },
        
        clients: [],
        pricelists: [],
        optionsUnit: [
          { value: 'Consumidor Final', text: 'Consumidor Final' },
          { value: 'Responsable Inscripto', text: 'Responsable Inscripto' },
          { value: 'Exento', text: 'Exento' },
          { value: 'Monotributo', text: 'Monotributo' },
        ]
      }
    },
    mounted() {
      this.clientIdExist();
      this.getPriceLists();
      this.resetForm();
      this.getAuthUser();
    },
    created() {
     this.$store.dispatch('salesClerks/getSalesclerks')
    },
    methods: {
      clientIdExist(){
        if (this.clientId != null) {
            let id = this.clientId;
            this.getClient(id);
            this.btnmessage="Editar Cliente";
          } else {
            this.btnmessage="Agregar Cliente";
            this.resetForm();
          }
        },
      close() {
        this.$emit('close');
      },
      getClient(id) {
        var vm = this;
        this.$http.get('/api/clients/getClient/' + id).then((response) => {
          vm.client = response.data.data
        })
      },
      getPriceLists() {
        console.log(this.clientId);
        var vm = this;
        this.$http.get('/api/priceslist/getPriceList').then((response) => {
          vm.pricelists = response.data.data
        })
      },
      saveClient() {
        if (this.isSaving) return;
        this.isSaving = true;
        var vm = this;
        if (this.client.cuit) {
          this.client.cuit = String(this.client.cuit).replace(/\D/g, '');
        }
        if (this.client.id != null) {
          this.$http.post('/api/clients/edit/' + this.client.id, this.client).then(() => {

            vm.resetForm();
            vm.$emit('confirmsave');
            vm.$emit('close');
          }).finally(() => {
            vm.isSaving = false;
          })
        } else {
          this.$http.post('/api/clients/add', this.client).then(() => {
            vm.resetForm();
            vm.$emit('confirmsave');
            vm.$emit('close');
          }).finally(() => {
            vm.isSaving = false;
          })
        }
      },
      resetForm() {
        this.client = Object.assign({}, this.emptyClient);
      },
      getAuthUser() {
        this.$http
          .get("/api/users/getAuthUser", {
            headers: { 
              Authorization: "Bearer " + localStorage.getItem("token")
            },
          })
          .then((response) => {
            this.hasPermission = response.data.data.permissions.includes('ACCESS_ALL_BRANCHOFFICES_SALES');
            this.salesclerkModule = response.data.data.branchoffices[0].options.salesclerk_module;
            this.paymentMethodCC = response.data.data.branchoffices[0].payments_methods.cuenta_corriente;
          })
      },
      updateTransports(t_list){
        this.client.t_list= t_list;
      },
      getAfipClientData() {
        this.$http.get('/api/clients/getAfipClientData/' + this.client.cuit).then((response) => {
          if (response.data.success !== true) return;
          const afipData = response.data.data;
          this.client.cuit = afipData.cuit;
          this.client.name = afipData.nombre;
          this.client.business = afipData.razonSocial;
          this.client.address = afipData.domicilios[0].direccion;
          this.client.city = afipData.domicilios[0].localidad;
          this.client.province = afipData.domicilios[0].descripcionProvincia;
          this.client.postalcode = afipData.domicilios[0].codigoPostal;
        });
      }
    },    
    computed: {
      codigoValido() {
          return isNaN(this.client.code) ? false : null
      },
      ivaTypeOptions() {
        return this.optionsUnit.map(opt => ({ value: opt.value, label: opt.text }));
      },
      priceListOptions() {
        return this.pricelists.map(pricelist => ({ value: pricelist.id, label: pricelist.name }));
      },
      salesClerkOptions() {
        return this.salesClerks.map(clerk => ({ value: clerk.id, label: clerk.name }));
      },
      ...mapState('salesClerks',{
        salesClerks: state => state.salesClerks,
      })
    }
  }
</script>

<style scoped>
.modal-mask-product {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(16, 24, 40, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: hidden;
}

.modal-dialog {
  margin: 0;
  width: 100%;
  max-width: 560px;
}

.modal-content {
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.18);
  overflow: hidden;
}

.modal-body {
  max-height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px 24px;
}

.modal-enter,
.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-content,
.modal-leave-active .modal-content {
  transform: scale(1.02);
}
</style>